import api from './api';

/**
 * Obtiene y devuelve directamente el objeto del usuario autenticado.
 * @returns {Promise<object>} El objeto de usuario.
 */
export const fetchUserApi = async () => {
  //console.info("🔍 Fetching user data from API...");
  // `api.get` devuelve el DTO del backend gracias a tu interceptor
  const response = await api.get('/api/user');
  // Devolvemos directamente la propiedad que nos interesa
  //console.info("✅ User data fetched successfully:", response.data.user);
  return response.data.user; 
};

// ... (el resto de funciones no cambian)
export const loginApi = (email, password) => {
  return api.post('/api/login', { email, password });
};

export const logoutApi = () => {
  return api.post('/api/logout');
};

/**
 * Llama al endpoint para cambiar el jugador activo del usuario.
 * @param {number} playerId - El ID del jugador a seleccionar.
 * @returns {Promise<object>} La respuesta del backend.
 */
export const selectPlayerApi = (playerId) => {
    return api.post(`/api/players/${playerId}/select`);
};